import { render, staticRenderFns } from "./ParametrosConfig.vue?vue&type=template&id=7cd9624b&"
import script from "./ParametrosConfig.vue?vue&type=script&lang=js&"
export * from "./ParametrosConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports